import { baseApi } from "./baseApi";

const BSL_BASE_URL = "/branch-shipment-location";

export const branchShipmentLocationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Branch-level summary: count per branch
    listBSLReport: builder.query({
      query: (params) => ({
        url: `${BSL_BASE_URL}/report`,
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ branch }) => ({
                type: "BranchShipmentLocation",
                id: branch,
              })),
              { type: "BranchShipmentLocation", id: "REPORT" },
            ]
          : [{ type: "BranchShipmentLocation", id: "REPORT" }],
    }),

    // Shipment-level detail: individual shipments with branch & destination info
    listBSLView: builder.query({
      query: (params) => ({
        url: `${BSL_BASE_URL}/view`,
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "BranchShipmentLocation",
                id: _id,
              })),
              { type: "BranchShipmentLocation", id: "VIEW" },
            ]
          : [{ type: "BranchShipmentLocation", id: "VIEW" }],
    }),
  }),
});

export const { useLazyListBSLReportQuery, useLazyListBSLViewQuery } =
  branchShipmentLocationApi;